// @ts-nocheck
import { IProjectModel } from '../models/ProjectModel';
import { IDeveloperModel } from '../models/DeveloperModel';
import { ITempProjectModel } from '../models/TempProjectModel';
import { IProjectTaskModel } from '../models/ProjectTaskModel';
import { IPhaseModel } from '../models/PhaseModel';
import { IBoard } from '../components/kanbanBoard/models/BoardModel';
import { IReleaseDropdown } from '../models/ReleaseDropdown';
import { IIdValueModel } from '../models/IIdValueModel';
import { IIdModel } from '../models/IIdModel';
import { IPhaseDropdown } from '../models/IPhaseDropdown';
import { FrontendVisibility } from '../models/ISettingsFrontend';

export enum ProjectActions {
  FETCH_CURRENT_PROJECTS = 'FETCH_CURRENT_PROJECTS',
  FETCH_CURRENT_PROJECTS_SUCCESS = 'FETCH_CURRENT_PROJECTS_SUCCESS',
  FETCH_CURRENT_PROJECTS_SILENT_SUCCESS = 'FETCH_CURRENT_PROJECTS_SILENT_SUCCESS',
  FETCH_CURRENT_PROJECTS_SILENT_ERROR = 'FETCH_CURRENT_PROJECTS_SILENT_ERROR',
  FETCH_CURRENT_PROJECTS_ERROR = 'FETCH_CURRENT_PROJECTS_ERROR',
  FETCH_PROJECT = 'FETCH_PROJECT',
  FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS',
  FETCH_PROJECT_ERROR = 'FETCH_PROJECT_ERROR',
  FETCH_PROJECT_PHASES = 'FETCH_PROJECT_PHASES',
  FETCH_PROJECT_PHASES_SUCCESS = 'FETCH_PROJECT_PHASES_SUCCESS',
  SET_PROJECT_LOADER = 'SET_PROJECT_LOADER',
  FETCH_PROJECT_ARCHIVE_PHASE = 'FETCH_PROJECT_ARCHIVE_PHASE',
  FETCH_PROJECT_ARCHIVE_PHASE_SUCCESS = 'FETCH_PROJECT_ARCHIVE_PHASE_SUCCESS',
  FETCH_PROJECT_ARCHIVE_PHASE_ERROR = 'FETCH_PROJECT_ARCHIVE_PHASE_ERROR',
  SET_PROJECT_ARCHIVE_PHASE = 'SET_PROJECT_ARCHIVE_PHASE',
  REMOVE_PROJECT_ARCHIVE_PHASE = 'REMOVE_PROJECT_ARCHIVE_PHASE',
  FETCH_PROJECT_PHASES_ERROR = 'FETCH_PROJECT_PHASES_ERROR',
  FETCH_DEVELOPERS = 'FETCH_DEVELOPERS',
  FETCH_DEVELOPERS_SUCCESS = 'FETCH_DEVELOPERS_SUCCESS',
  FETCH_DEVELOPERS_ERROR = 'FETCH_DEVELOPERS_ERROR',
  CHANGE_TASK_PHASE = 'CHANGE_TASK_PHASE',
  CHANGE_TASK_PHASE_SUCCESS = 'CHANGE_TASK_PHASE_SUCCESS',
  CHANGE_TASK_PHASE_ERROR = 'CHANGE_TASK_PHASE_ERROR',
  RESTORE_TASK_PHASE_MOVE = 'RESTORE_TASK_PHASE_MOVE',
  UPDATE_TASK_PHASE = 'UPDATE_TASK_PHASE',
  DRAG_HAPPEND = 'DRAG_HAPPEND',
  DRAG_LIST_HAPPEND = 'DRAG_LIST_HAPPEND',
  CHANGE_PROJECT_PHASE_ORDER = 'CHANGE_PROJECT_PHASE_ORDER',
  CHANGE_PROJECT_PHASE_ORDER_ERROR = 'CHANGE_PROJECT_PHASE_ORDER_ERROR',
  CHANGE_TASK_DURATION_AND_PRIORITY = 'CHANGE_TASK_DURATION_AND_PRIORITY',
  CHANGE_TASK_DURATION_AND_PRIORITY_ERROR = 'CHANGE_TASK_DURATION_AND_PRIORITY_ERROR',
  CHANGE_TASK_DURATION_AND_PRIORITY_SUCCESS = 'CHANGE_TASK_DURATION_AND_PRIORITY_SUCCESS',
  CREATE_MULTIPLE_TASKS = 'CREATE_MULTIPLE_TASKS',
  CREATE_MULTIPLE_TASKS_SUCCESS = 'CREATE_MULTIPLE_TASKS_SUCCESS',
  CREATE_MULTIPLE_TASKS_ERROR = 'CREATE_MULTIPLE_TASKS_ERROR',
  CREATE_PROJECT_PHASE = 'CREATE_PROJECT_PHASE',
  CREATE_PROJECT_PHASE_SUCCESS = 'CREATE_PROJECT_PHASE_SUCCESS',
  CREATE_PROJECT_PHASE_ERROR = 'CREATE_PROJECT_PHASE_ERROR',
  SET_BOARD_SORTING_TYPE = 'SET_BOARD_SORTING_TYPE',
  SET_CURRENT_PROJECT_RELEASE = 'SET_CURRENT_PROJECT_RELEASE',
  ARCHIVE_ALL_PHASE_TASKS = 'ARCHIVE_ALL_PHASE_TASKS',
  ARCHIVE_ALL_PHASE_TASKS_SUCCESS = 'ARCHIVE_ALL_PHASE_TASKS_SUCCESS',
  ARCHIVE_ALL_PHASE_TASKS_ERROR = 'ARCHIVE_ALL_PHASE_TASKS_ERROR',
  MOVE_TO_RELEASE_ALL_PHASE_TASKS = 'MOVE_TO_RELEASE_ALL_PHASE_TASKS',
  MOVE_TO_RELEASE_ALL_PHASE_TASKS_SUCCESS = 'MOVE_TO_RELEASE_ALL_PHASE_TASKS_SUCCESS',
  MOVE_TO_RELEASE_ALL_PHASE_TASKS_ERROR = 'MOVE_TO_RELEASE_ALL_PHASE_TASKS_ERROR',
  GET_RELEASES_ALL_PHASE_TASKS = 'GET_RELEASES_ALL_PHASE_TASKS',
  GET_RELEASES_ALL_PHASE_TASKS_SUCCESS = 'GET_RELEASES_ALL_PHASE_TASKS_SUCCESS',
  GET_RELEASES_ALL_PHASE_TASKS_ERROR = 'GET_RELEASES_ALL_PHASE_TASKS_ERROR',
  RENAME_PHASE = 'RENAME_PHASE',
  RENAME_PHASE_SUCCESS = 'RENAME_PHASE_SUCCESS',
  ERROR = 'ERROR',
  DELETE_PHASE = 'DELETE_PHASE',
  DELETE_PHASE_SUCCESS = 'DELETE_PHASE_SUCCESS',
  DELETE_PHASE_ERROR = 'DELETE_PHASE_ERROR',
  MOVE_TO_PHASE_ALL_PHASE_TASKS = 'MOVE_TO_PHASE_ALL_PHASE_TASKS',
  MOVE_TO_PHASE_ALL_PHASE_TASKS_SUCCESS = 'MOVE_TO_PHASE_ALL_PHASE_TASKS_SUCCESS',
  MOVE_TO_PHASE_ALL_PHASE_TASKS_ERROR = 'MOVE_TO_PHASE_ALL_PHASE_TASKS_ERROR',
  GET_PHASES_ALL_PHASE_TASKS = 'GET_PHASES_ALL_PHASE_TASKS',
  GET_PHASES_ALL_PHASE_TASKS_SUCCESS = 'GET_PHASES_ALL_PHASE_TASKS _SUCCESS',
  GET_PHASES_ALL_PHASE_TASKS_ERROR = 'GET_PHASES_ALL_PHASE_TASKS_ERROR',
  CHANGE_VISIBILITY_OF_LANE_PHASE = 'CHANGE_VISIBILITY_OF_LANE_PHASE',
  CHANGE_VISIBILITY_OF_LANE_PHASE_SUCCESS = 'CHANGE_VISIBILITY_OF_LANE_PHASE_SUCCESS',
  CHANGE_VISIBILITY_OF_LANE_PHASE_ERROR = 'CHANGE_VISIBILITY_OF_LANE_PHASE_ERROR',
}

export interface ProjectState {
  projects: ITempProjectModel[];
  project: IProjectModel;
  developers: IDeveloperModel[];
  board: IBoard<IProjectTaskModel>;
  currentProjectReleaseId: number | null;
  currentSortingType: number;
  loading: boolean;
  releaseDropdown: IReleaseDropdown[];
  phaseDropdown: IPhaseDropdown[];
  errors: ProjectStateError;
}

export interface ProjectStateError {
  currentProjects?: string;
  project?: string;
  projectPhases?: string;
  developers?: string;
  taskPhase?: string;
  phaseOrder?: string;
  changeTaskDurationAndPriority?: string;
  createMultipleTasks?: string;
  createProjectPhase?: string;
  renamePhase?: string;
  archiveAllPhaseTasks?: string;
  getReleasesAllPhaseTasks?: string;
  moveToReleaseAllPhaseTasks?: string;
  getPhasesAllPhaseTasks?: string;
  moveToPhaseAllPhaseTasks?: string;
  deletePhase?: string;
  changeVisibilityOfLanePhase?: string;
  error?: string;
  [key: string]: string | undefined;
}

interface FetchCurrentProjectsAction {
  type: ProjectActions.FETCH_CURRENT_PROJECTS;
  payload?: any;
}

interface FetchCurrentProjectsSuccessAction {
  type: ProjectActions.FETCH_CURRENT_PROJECTS_SUCCESS;
  payload: ITempProjectModel[];
}

interface FetchCurrentProjectsSilentSuccessAction {
  type: ProjectActions.FETCH_CURRENT_PROJECTS_SILENT_SUCCESS;
  payload: ITempProjectModel[];
}

interface FetchCurrentProjectsErrorAction {
  type: ProjectActions.FETCH_CURRENT_PROJECTS_ERROR;
  payload: string;
}

interface FetchCurrentProjectsSilentErrorAction {
  type: ProjectActions.FETCH_CURRENT_PROJECTS_SILENT_ERROR;
  payload: string;
}

interface FetchProjectAction {
  type: ProjectActions.FETCH_PROJECT;
  payload?: any;
}

interface FetchProjectSuccessAction {
  type: ProjectActions.FETCH_PROJECT_SUCCESS;
  payload: IProjectModel;
}

interface FetchProjectErrorAction {
  type: ProjectActions.FETCH_PROJECT_ERROR;
  payload: string;
}

interface FetchProjectPhasesAction {
  type: ProjectActions.FETCH_PROJECT_PHASES;
  payload?: any;
}

interface FetchProjectPhasesSuccessAction {
  type: ProjectActions.FETCH_PROJECT_PHASES_SUCCESS;
  payload?: IPhaseModel[];
}
interface ProjectLoaderAction {
  type: ProjectActions.SET_PROJECT_LOADER;
  payload: boolean;
}
interface FetchProjectArchivePhaseAction {
  type: ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE;
  payload?: any;
}
interface FetchProjectArchivePhaseSuccessAction {
  type: ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE_SUCCESS;
  payload?: IPhaseModel[];
}
interface FetchProjectArchivePhaseErrorAction {
  type: ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE_ERROR;
  payload?: string;
}
interface AddProjectArchivePhaseAction {
  type: ProjectActions.SET_PROJECT_ARCHIVE_PHASE;
}
interface RemoveProjectArchivePhaseAction {
  type: ProjectActions.REMOVE_PROJECT_ARCHIVE_PHASE;
}
interface FetchProjectPhasesErrorAction {
  type: ProjectActions.FETCH_PROJECT_PHASES_ERROR;
  payload?: string;
}

interface FetchDevelopersAction {
  type: ProjectActions.FETCH_DEVELOPERS;
  payload?: any;
}

interface FetchDevelopersSuccessAction {
  type: ProjectActions.FETCH_DEVELOPERS_SUCCESS;
  payload?: IDeveloperModel[];
}

interface FetchDevelopersErrorAction {
  type: ProjectActions.FETCH_DEVELOPERS_ERROR;
  payload?: any;
}

interface ChangeTaskPhaseAction {
  type: ProjectActions.CHANGE_TASK_PHASE;
  payload?: any;
}

interface ChangeTaskPhaseSuccessAction {
  type: ProjectActions.CHANGE_TASK_PHASE_SUCCESS;
  payload: IProjectTaskModel;
}

interface ChangeTaskPhaseErrorAction {
  type: ProjectActions.CHANGE_TASK_PHASE_ERROR;
  payload: string;
}

interface RestoreTaskPhaseMoveAction {
  type: ProjectActions.RESTORE_TASK_PHASE_MOVE;
  payload: {
    project: IProjectModel;
    board: IBoard<IProjectTaskModel>;
  };
}

interface UpdateTaskPhaseAction {
  type: ProjectActions.UPDATE_TASK_PHASE;
  payload: {
    droppableIdStart: string;
    droppableIdEnd: string;
    droppableIndexStart: number;
    droppableIndexEnd: number;
    draggableId: string;
    selectedRelease: number | null;
    sortingType: number;
  };
}

interface DragHappendAction {
  type: ProjectActions.DRAG_HAPPEND;
  payload: {
    droppableIdStart: string;
    droppableIdEnd: string;
    droppableIndexStart: number;
    droppableIndexEnd: number;
    draggableId: string;
  };
}

interface DragListHappendAction {
  type: ProjectActions.DRAG_LIST_HAPPEND;
  payload: {
    projectId: number;
    indexStart: number;
    indexEnd: number;
  };
}

interface ChangeProjectPhaseOrderAction {
  type: ProjectActions.CHANGE_PROJECT_PHASE_ORDER;
  payload?: any;
}

interface ChangeProjectPhaseOrderErrorAction {
  type: ProjectActions.CHANGE_PROJECT_PHASE_ORDER_ERROR;
  payload: string;
}

interface ChangeTaskDurationAndPriorityAction {
  type: ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY;
  payload?: any;
}

interface ChangeTaskDurationAndPrioritySuccessAction {
  type: ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY_SUCCESS;
  payload: IProjectTaskModel;
}

interface ChangeTaskDurationAndPriorityErrorAction {
  type: ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY_ERROR;
  payload: string;
}

interface CreateMultipleTasksAction {
  type: ProjectActions.CREATE_MULTIPLE_TASKS;
  payload?: any;
}

interface CreateMultipleTasksSuccessAction {
  type: ProjectActions.CREATE_MULTIPLE_TASKS_SUCCESS;
  payload: IProjectTaskModel[];
}

interface CreateMultipleTasksErrorAction {
  type: ProjectActions.CREATE_MULTIPLE_TASKS_ERROR;
  payload: string;
}

interface CreateProjectPhaseAction {
  type: ProjectActions.CREATE_PROJECT_PHASE;
  payload?: any;
}

interface CreateProjectPhaseSuccessAction {
  type: ProjectActions.CREATE_PROJECT_PHASE_SUCCESS;
  payload: IPhaseModel;
}

interface CreateProjectPhaseErrorAction {
  type: ProjectActions.CREATE_PROJECT_PHASE_ERROR;
  payload: string;
}

interface ChangeBoardSortingTypeAction {
  type: ProjectActions.SET_BOARD_SORTING_TYPE;
  payload: { sortingType: number };
}

interface ChangeCurrentProjectReleaseAction {
  type: ProjectActions.SET_CURRENT_PROJECT_RELEASE;
  payload: { projectReleaseId: number | null };
}

interface ArchiveAllPhaseTasksAction {
  type: ProjectActions.ARCHIVE_ALL_PHASE_TASKS;
  payload?: any;
}

interface ArchiveAllPhaseTasksSuccessAction {
  type: ProjectActions.ARCHIVE_ALL_PHASE_TASKS_SUCCESS;
  payload: { phaseId: number | string };
}

interface ArchiveAllPhaseTasksErrorAction {
  type: ProjectActions.ARCHIVE_ALL_PHASE_TASKS_ERROR;
  payload: string;
}

interface MoveToReleaseAllPhaseTasksAction {
  type: ProjectActions.MOVE_TO_RELEASE_ALL_PHASE_TASKS;
  payload?: any;
}

interface MoveToReleaseAllPhaseTasksSuccessAction {
  type: ProjectActions.MOVE_TO_RELEASE_ALL_PHASE_TASKS_SUCCESS;
  payload: {
    phaseId: string | number;
    projectReleaseIdNew: string | number;
    projectReleaseIdCurrent?: string | number;
  };
}

interface MoveToReleaseAllPhaseTasksErrorAction {
  type: ProjectActions.MOVE_TO_RELEASE_ALL_PHASE_TASKS_ERROR;
  payload: string;
}

interface MoveToPhaseAllPhaseTasksAction {
  type: ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS;
  payload?: any;
}

interface MoveToPhaseAllPhaseTasksSuccessAction {
  type: ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS_SUCCESS;
  payload: {
    phaseIdNew: string | number;
    phaseIdCurrent: string | number;
  };
}

interface moveToPhaseAllPhaseTasksErrorAction {
  type: ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS_ERROR;
  payload: string;
}

interface GetReleasesAllPhaseTasksAction {
  type: ProjectActions.GET_RELEASES_ALL_PHASE_TASKS;
  payload?: any;
}

interface GetReleasesAllPhaseTasksSuccessAction {
  type: ProjectActions.GET_RELEASES_ALL_PHASE_TASKS_SUCCESS;
  payload: IReleaseDropdown[];
}

interface GetReleasesAllPhaseTasksErrorAction {
  type: ProjectActions.GET_RELEASES_ALL_PHASE_TASKS_ERROR;
  payload: string;
}

interface GetPhasesAllPhaseTaskAction {
  type: ProjectActions.GET_PHASES_ALL_PHASE_TASKS;
  payload?: any;
}

interface GetPhasesAllPhaseTaskSuccessAction {
  type: ProjectActions.GET_PHASES_ALL_PHASE_TASKS_SUCCESS;
  payload: IPhaseDropdown[];
}

interface GetPhasesAllPhaseTaskErrorAction {
  type: ProjectActions.GET_PHASES_ALL_PHASE_TASKS_ERROR;
  payload: string;
}

interface DeletePhaseAction {
  type: ProjectActions.DELETE_PHASE;
  payload?: any;
}

interface DeletePhaseSuccessAction {
  type: ProjectActions.DELETE_PHASE_SUCCESS;
  payload: IIdModel<number, number>;
}

interface DeletePhaseErrorAction {
  type: ProjectActions.DELETE_PHASE_ERROR;
  payload: string;
}

interface RenamePhaseAction {
  type: ProjectActions.RENAME_PHASE;
  payload?: any;
}

interface RenamePhaseSuccessAction {
  type: ProjectActions.RENAME_PHASE_SUCCESS;
  payload: IIdValueModel<number, string>;
}

interface ErrorAction {
  type: ProjectActions.ERROR;
  payload: string;
}

interface ChangeVisibilityOfLanePhaseAction {
  type: ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE;
  payload?: any;
}

interface ChangeVisibilityOfLanePhaseSuccessAction {
  type: ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE_SUCCESS;
  payload: { phaseId: number; visibility: FrontendVisibility };
}

interface ChangeVisibilityOfLanePhaseErrorAction {
  type: ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE_ERROR;
  payload: string;
}

export type ProjectAction =
  | FetchCurrentProjectsAction
  | FetchCurrentProjectsSuccessAction
  | FetchCurrentProjectsSilentSuccessAction
  | FetchCurrentProjectsErrorAction
  | FetchCurrentProjectsSilentErrorAction
  | FetchProjectAction
  | FetchProjectSuccessAction
  | FetchProjectErrorAction
  | FetchProjectPhasesAction
  | FetchProjectPhasesSuccessAction
  | ProjectLoaderAction
  | FetchProjectArchivePhaseAction
  | FetchProjectArchivePhaseSuccessAction
  | FetchProjectArchivePhaseErrorAction
  | AddProjectArchivePhaseAction
  | RemoveProjectArchivePhaseAction
  | FetchProjectPhasesErrorAction
  | FetchDevelopersAction
  | FetchDevelopersSuccessAction
  | FetchDevelopersErrorAction
  | ChangeTaskPhaseAction
  | ChangeTaskPhaseSuccessAction
  | ChangeTaskPhaseErrorAction
  | RestoreTaskPhaseMoveAction
  | UpdateTaskPhaseAction
  | DragHappendAction
  | DragListHappendAction
  | ChangeProjectPhaseOrderAction
  | ChangeProjectPhaseOrderErrorAction
  | ChangeTaskDurationAndPriorityAction
  | ChangeTaskDurationAndPriorityErrorAction
  | ChangeTaskDurationAndPrioritySuccessAction
  | CreateMultipleTasksAction
  | CreateMultipleTasksSuccessAction
  | CreateMultipleTasksErrorAction
  | CreateProjectPhaseAction
  | CreateProjectPhaseSuccessAction
  | CreateProjectPhaseErrorAction
  | ChangeBoardSortingTypeAction
  | ChangeCurrentProjectReleaseAction
  | ArchiveAllPhaseTasksAction
  | ArchiveAllPhaseTasksSuccessAction
  | ArchiveAllPhaseTasksErrorAction
  | MoveToReleaseAllPhaseTasksAction
  | MoveToReleaseAllPhaseTasksSuccessAction
  | MoveToReleaseAllPhaseTasksErrorAction
  | MoveToPhaseAllPhaseTasksAction
  | MoveToPhaseAllPhaseTasksSuccessAction
  | moveToPhaseAllPhaseTasksErrorAction
  | GetReleasesAllPhaseTasksAction
  | GetReleasesAllPhaseTasksSuccessAction
  | GetReleasesAllPhaseTasksErrorAction
  | GetPhasesAllPhaseTaskAction
  | GetPhasesAllPhaseTaskSuccessAction
  | GetPhasesAllPhaseTaskErrorAction
  | RenamePhaseAction
  | RenamePhaseSuccessAction
  | ErrorAction
  | DeletePhaseAction
  | DeletePhaseSuccessAction
  | DeletePhaseErrorAction
  | ChangeVisibilityOfLanePhaseAction
  | ChangeVisibilityOfLanePhaseSuccessAction
  | ChangeVisibilityOfLanePhaseErrorAction;
